import React from 'react';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { fg } from '@confluence/feature-gating';

import { BylineContainer, BylineMessageContainer } from './ContentOwnershipStyles.tsx';
import { PageOwnershipBylineContent } from './PageOwnershipBylineContent.tsx';
import { PageOwnershipBylinePopupHandler } from './PageOwnershipBylinePopupHandler.tsx';
import type { UserShape } from './ownership-models.ts';

type PageOwnershipBylineProps = {
	owner: UserShape;
	creator: UserShape;
	createdDate: Date | null;
	templateId: string | null;
	contentId: string | null;
	lastOwner: UserShape | null;
	generatedBy?: string | null;
};
export const PageOwnershipByline = ({
	owner,
	creator,
	createdDate,
	templateId,
	contentId,
	lastOwner,
	generatedBy,
}: PageOwnershipBylineProps) => {
	const isLivePage = useIsCurrentPageLive();

	return (
		<BylineContainer>
			<BylineMessageContainer>
				<PageOwnershipBylineContent
					owner={owner}
					templateId={templateId}
					abbreviateBylineText={isLivePage || fg('cc_page_experiences_new_editor_byline')}
					generatedBy={generatedBy}
				/>
			</BylineMessageContainer>
			{!isLivePage && !fg('cc_page_experiences_new_editor_byline') && (
				<PageOwnershipBylinePopupHandler
					creator={creator}
					createdDate={createdDate}
					ownedByAccountId={owner.userId}
					contentId={contentId}
					lastOwner={lastOwner}
				/>
			)}
		</BylineContainer>
	);
};
